import { Row, Typography } from "antd";
import React from "react";
import { useMemo } from "react";
import { formatNumber } from "src/utils/formatting";


const { Text, Title } = Typography; 

interface AirConditionTagProps{
    title: string;
    useCelsius: boolean;
    temp: number | null | undefined;
    rh: number | null | undefined;
    emc: number | null | undefined;
}

const AirConditionTag : React.FC<AirConditionTagProps> = ({ title, useCelsius, temp, rh, emc }) => {

    const tagStyle = {
        backgroundColor: '#f5f5f5',
        border: '2px solid black',
        borderRadius: '999px',
        borderColor:  '#000000',
    }

    const tagTextStyle = {
        padding: '2px 12px',
        fontSize: '12px',
        fontFamily: 'monospace',
        fontWeight: 'bold',
        color: '#000000',
        whiteSpace: 'nowrap',
    }

    const displayTemp = useMemo( () => {


        return formatNumber(temp, { decimalPlaces: 1, showSuffixIfNoValue: true, suffix: useCelsius ? '°C' : '°F'});
    }, [temp]);

    const displayRh = useMemo( () => {
        if(rh == null){
            return '--';
        }
        return formatNumber(rh, { decimalPlaces: 1, showSuffixIfNoValue: true, suffix: '% RH'});
    }, [rh]);

    const displayEmc = useMemo( () => {
        if(emc == null){
            return '--';
        }
        return formatNumber(emc, { decimalPlaces: 1, showSuffixIfNoValue: true, suffix: '% EMC'});
    }, [emc]);

    return(
        <>
            <Row>
                <Text>{title}</Text>
            </Row>
            <Row style={tagStyle}>
                <Text style={tagTextStyle}>{displayTemp} | {displayRh} | {displayEmc}</Text>
            </Row>
        </>
    )
}

export default AirConditionTag;